import { useEffect, useState } from 'react';
import axiosInstance from 'utils/axiosInterceptors';
import { TCurrentUserDetails } from 'utils/types';

const useFetchUserDetails = () => {
  const [userDetails, setUserDetails] = useState<TCurrentUserDetails | null>(
    null
  );

  const fetchCurrenUserDetails = async () => {
    try {
      const res = await axiosInstance.get(`/api/v1/users/currentUserDetail`);
      setUserDetails(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCurrenUserDetails();
  }, []);

  return { userDetails };
};

export default useFetchUserDetails;
